import defu from "defu";

export default defineNuxtPlugin({
  name: "ckweb:hooks",
  enforce: "pre",
  dependsOn: ["ckweb:settings", "ckweb:dev-console"],
  setup: ($nuxt) => {
    const config = useRuntimeConfig();
    const authOptions = defu(
      {
        hygiena: {
          appName: config.public.HYGIENA_AUTH_JETSETTER_APP_NAME,
          baseUrl: config.public.HYGIENA_AUTH_URL,
          redirectUri: "/",
          postLogoutRedirectUri: "/login",
          elementContainer: "#hygiena-auth-container",
          attributes: {
            "register-href": `${config.public.APP_URL_SETUP}/subscription`,
            "forgot-password-href": `${config.public.APP_URL_SETUP}/forgot-password`,
            "username-placeholder": () => $nuxt.$i18n.t("auth.enterUsername"),
            "password-placeholder": () => $nuxt.$i18n.t("auth.enterPassword"),
          },
          labels: {
            "forgot-password-label": () => $nuxt.$i18n.t("auth.forgotUsernameOrPassword"),
            "submit-label": () => $nuxt.$i18n.t("auth.submitLabel"),
            "register-prompt-label": () => $nuxt.$i18n.t("auth.registerPromptLabel"),
            "register-label": () => $nuxt.$i18n.t("auth.registerLabel"),
          },
        },
      },
      config.public.AUTH_OPTIONS,
    );

    config.public.AUTH_OPTIONS = authOptions;
    devConsole.info("🛠️ ckClient: custom config applied  🚀🚀🚀🚀🚀");
  },
});
